var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcoDrk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0603695 6.7165C0.0909939 6.64738 0.832119 5.00325 2.47974 3.35562C4.67512 1.16025 7.448 0 10.5 0C13.552 0 16.3249 1.16025 18.5203 3.35562C20.1679 5.00325 20.9125 6.65 20.9396 6.7165C20.9794 6.80602 21 6.9029 21 7.00087C21 7.09885 20.9794 7.19573 20.9396 7.28525C20.909 7.35437 20.1679 8.99763 18.5203 10.6452C16.3249 12.8397 13.552 14 10.5 14C7.448 14 4.67512 12.8397 2.47974 10.6452C0.832119 8.99763 0.0909939 7.35437 0.0603695 7.28525C0.0205688 7.19573 0 7.09885 0 7.00087C0 6.9029 0.0205688 6.80602 0.0603695 6.7165ZM10.5 10.5C11.1922 10.5 11.8689 10.2947 12.4445 9.91014C13.0201 9.52556 13.4687 8.97893 13.7336 8.33939C13.9985 7.69985 14.0678 6.99612 13.9328 6.31718C13.7977 5.63825 13.4644 5.01461 12.9749 4.52513C12.4854 4.03564 11.8618 3.7023 11.1828 3.56725C10.5039 3.4322 9.80015 3.50151 9.16061 3.76642C8.52107 4.03133 7.97444 4.47993 7.58985 5.0555C7.20527 5.63108 7 6.30777 7 7C7 7.92826 7.36875 8.8185 8.02512 9.47487C8.6815 10.1313 9.57174 10.5 10.5 10.5Z",
    fill: "#B0B0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcoDrk);
export default __webpack_public_path__ + "static/media/eye_ico_drk.6a64e8b72bd2d001ec11fe2fbe6851d6.svg";
export { ForwardRef as ReactComponent };